import { useQuery } from "@tanstack/react-query";
import { GetUserRoleService } from "../../../../common/services/dropdown";

export const useQueryUserRoleForSelect = (
    params?: any,
    uriValue = true
  ) => {
  return useQuery({
    queryKey: ["queryUserRole"],
    queryFn: async () => GetUserRoleService.getRoles(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};